import { useEffect, FC } from 'react'

import { useDispatch } from 'react-redux'

import { UniNoticeId } from 'api/uninotice/uniNoticeApi'
import { inlineNoticePath } from 'components/paths'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { push, replace } from 'functions/router'

export const UniNoticeInlineRedirect: FC<{
  watchedNotice: UniNoticeId
  replace: boolean
}> = ({ watchedNotice, replace: isReplace }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    const method = isReplace ? replace : push
    dispatch(method(mergeAllUrls(inlineNoticePath, watchedNotice)))
  }, [dispatch, watchedNotice])

  return null
}
